import { useTranslation } from 'react-i18next';
import BrandLogo from '@/components/atoms/BrandLogo';

/** Route chunk loading reuses the entry motion without restarting the full-screen cover. */
export default function BrandLoading() {
  const { t } = useTranslation();
  return (
    <div
      className="gp-route-loading"
      role="status"
      aria-label={t('entry.label')}
    >
      <div className="gp-loading-mark" aria-hidden="true">
        <BrandLogo compact />
      </div>
      <p className="gp-loading-message">{t('entry.message')}</p>
      <span className="gp-loading-dots" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
    </div>
  );
}
